"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.processNumeric = exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _utils = require("@trs/utils");
var _input = require("../../input");
var _tooltip = require("../../tooltip");
var _misc = require("../../misc");
var _SearchableDEPRECATED = _interopRequireDefault(require("./Searchable.DEPRECATED.style"));
var _InputError = _interopRequireDefault(require("../../errors/InputError"));
var _PercentageToggler = _interopRequireDefault(require("./PercentageToggler"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var NUMERIC_CUTOFF = 12;
var processNumeric = function processNumeric(value) {
  if (!value) return '';
  var processed = value.replace(/^0{1,}/, '') || '0';
  return processed.indexOf('.') === 0 ? "0".concat(processed) : processed;
};
exports.processNumeric = processNumeric;
var handleScrollableDropdown = function handleScrollableDropdown(currentIndex) {
  var items = window.document.querySelectorAll('.list-menu-items');
  var itemsWrapper = window.document.querySelector('.list-menu-wrapper');
  if (!items.length) return;
  var elHeight = items[currentIndex].clientHeight;
  var wrapperScrollTop = itemsWrapper.scrollTop;
  var viewport = wrapperScrollTop + itemsWrapper.clientHeight;
  var elOffset = elHeight * currentIndex;
  if (elOffset < wrapperScrollTop || elOffset + elHeight > viewport) {
    itemsWrapper.scrollTop = elOffset;
  }
};
var Searchable = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Searchable, _React$PureComponent);
  var _super = _createSuper(Searchable);
  function Searchable(props) {
    var _this;
    _classCallCheck(this, Searchable);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "onChange", function (value) {
      var computedSearchValue;
      var regexPattern = _this.props.regexPattern;
      var isLetter = _this.props.employeeSearchable ? true : /[a-zA-Z]+/.test(value);
      if (regexPattern) {
        computedSearchValue = regexPattern.test(_this.state.searchValue + value) ? _this.state.searchValue + value : (_this.state.searchValue + value).slice(0, -1);
      } else {
        computedSearchValue = _this.state.searchValue + value;
      }
      var isNumeric = _this.props.employeeSearchable ? false : /^([0-9]*\.?[0-9]*|[0-9]*\.?|\.?[0-9]*)$/.test(computedSearchValue);
      if ((_this.props.numericOnly || _this.props.percentageOnly) && !isNumeric) return false;
      if (!_this.state.searchValue && isNumeric || _this.state.isNumeric) {
        if (!isNumeric) return false;
        var searchValue = processNumeric(computedSearchValue);
        _this.setState({
          isNumeric: true,
          searchValue: searchValue
        });
        _this.props.formulaChange({
          value: searchValue,
          type: _this.props.type === 'percentage' ? 'percentage' : 'numeric'
        });
        return false;
      }
      if (_this.state.searchValue || isLetter) {
        if (_this.state.emptyResults) {
          return false;
        }
        var _searchValue = computedSearchValue;
        _this.setState({
          searchValue: _searchValue,
          searchingResults: true,
          emptyResults: false
        });
        _this.autoCompleteVariables(_searchValue);
      }
      return false;
    });
    _defineProperty(_assertThisInitialized(_this), "handleClickOutside", function () {
      _this.setState({
        searchValue: '',
        showResultsDropdown: false,
        emptyResults: false,
        searchingResults: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleItemSelect", function (event, currentIndex) {
      if (_this.state.searchValue && _this.state.list.length) {
        var selectedItem = _this.state.list[currentIndex];
        _this.setState({
          searchValue: '',
          showResultsDropdown: false,
          list: []
        });
        if (!_this.props.employeeSearchable) {
          _this.props.formulaChange({
            value: "".concat(selectedItem.dataSource, ".").concat(selectedItem.value),
            description: selectedItem.description,
            dataSource: selectedItem.dataSource,
            type: 'variable',
            displayName: selectedItem.displayName
          });
        } else {
          _this.props.formulaChange(selectedItem);
        }
      }
      event.preventDefault();
    });
    _defineProperty(_assertThisInitialized(_this), "itemClick", function (item) {
      _this.setState({
        list: [],
        searchValue: '',
        showResultsDropdown: false
      });
      if (!_this.props.employeeSearchable) {
        _this.props.formulaChange({
          value: "".concat(item.dataSource, ".").concat(item.value),
          description: item.description,
          dataSource: item.dataSource,
          type: 'variable',
          displayName: item.displayName
        });
      } else {
        _this.props.formulaChange(item);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleKeyPress", function (event) {
      var currentIndex = _this.state.selectedListIndex;
      var isNumeric = _this.state.isNumeric;
      switch (event.key) {
        case 'Backspace':
          {
            if (!isNumeric && _this.state.searchValue) {
              var searchValue = _this.state.searchValue.slice(0, -1);
              _this.setState({
                searchValue: searchValue,
                searchingResults: searchValue,
                emptyResults: false,
                showResultsDropdown: false
              });
              _this.autoCompleteVariables(searchValue);
              return;
            }
            _this.setState({
              searchValue: '',
              showResultsDropdown: false,
              list: [],
              isNumeric: false
            });
            if (!_this.props.employeeSearchable) {
              _this.props.formulaChange({
                value: '',
                description: '',
                dataSource: '',
                type: 'variable'
              });
            } else {
              _this.props.formulaChange({
                employeeId: '',
                employeeName: '',
                country: '',
                email: ''
              });
            }
            break;
          }
        case 'Delete':
          _this.setState({
            searchValue: '',
            showResultsDropdown: false,
            list: [],
            isNumeric: false
          });
          if (!_this.props.employeeSearchable) {
            _this.props.formulaChange({
              value: '',
              description: '',
              dataSource: '',
              type: 'variable'
            });
          } else {
            _this.props.formulaChange({
              employeeId: '',
              employeeName: '',
              country: '',
              email: ''
            });
          }
          break;
        case 'Escape':
          _this.setState({
            searchValue: '',
            emptyResults: false,
            showResultsDropdown: false
          });
          break;
        case 'Tab':
          if (!isNumeric) _this.handleItemSelect(event, currentIndex);
          break;
        case 'Enter':
          if (!isNumeric) _this.handleItemSelect(event, currentIndex);
          break;
        case 'ArrowDown':
          currentIndex = currentIndex + 1 > _this.state.list.length - 1 ? 0 : currentIndex + 1;
          _this.setState({
            selectedListIndex: currentIndex
          });
          if (_this.props.employeeSearchable) {
            handleScrollableDropdown(currentIndex);
          }
          break;
        case 'ArrowUp':
          currentIndex = currentIndex - 1 < 0 ? _this.state.list.length - 1 : currentIndex - 1;
          _this.setState({
            selectedListIndex: currentIndex
          });
          if (_this.props.employeeSearchable) {
            handleScrollableDropdown(currentIndex);
          }
          break;
        default:
          break;
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handlingSearchableAction", function (searchValue) {
      _this.props.searchableAction(searchValue).then(function (data) {
        if (data && data.length) {
          _this.setState({
            list: _this.props.employeeSearchable ? data : data.slice(0, 10),
            showResultsDropdown: true,
            emptyResults: false,
            selectedListIndex: 0,
            searchingResults: false
          });
        } else {
          _this.setState({
            list: [],
            searchingResults: false,
            showResultsDropdown: false,
            emptyResults: _this.state.searchValue,
            selectedListIndex: 0
          });
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "autoCompleteVariables", (0, _utils.debounce)(function (searchValue) {
      return _this.props.employeeSearchable ? searchValue.length >= 3 && _this.handlingSearchableAction(searchValue) : _this.handlingSearchableAction(searchValue);
    }, 300));
    _defineProperty(_assertThisInitialized(_this), "renderSearchableComponent", function (_ref) {
      var value = _ref.value,
        _ref$searchValue = _ref.searchValue,
        searchValue = _ref$searchValue === void 0 ? value : _ref$searchValue;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
        className: "formula-search-value ".concat(searchValue.length > NUMERIC_CUTOFF && !_this.props.employeeSearchable ? 'formula-direction-rtl' : ''),
        dangerouslySetInnerHTML: {
          __html: searchValue.replace(/\s/g, '&nbsp;')
        }
      }), /*#__PURE__*/_react["default"].createElement(_input.Input, {
        onKeyDown: _this.handleKeyPress,
        required: true,
        className: "rule-formula ".concat(searchValue || value ? 'no-placeholder' : ''),
        name: _this.props.id,
        id: _this.props.id || "rule-".concat(_this.props.ruleIndex, "-formula-input-").concat(_this.props.keysPath.join('-')),
        value: "",
        onChange: function onChange(event) {
          event.persist();
          _this.onChange(event.target.value);
        },
        icon: _this.props.searchIcon ? 'ion-android-search' : undefined,
        placeholder: searchValue || value ? '' : _this.props.placeholder || _this.props.labels.FORMULA_INPUT_PLACEHOLDER
      }), _this.props.type === 'percentage' && !_this.props.isFocused ? value && /*#__PURE__*/_react["default"].createElement("span", {
        className: "searchable-percentage"
      }, "%") : '', _this.state.isNumeric && _this.props.isFocused && /*#__PURE__*/_react["default"].createElement(_PercentageToggler["default"], {
        percentageOnly: _this.props.percentageOnly,
        numericOnly: _this.props.numericOnly,
        formulaChange: _this.props.formulaChange,
        type: _this.props.type,
        value: searchValue || value
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "renderDropdown", function () {
      if (_this.state.showResultsDropdown) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          ref: _this.listRef
        }, /*#__PURE__*/_react["default"].createElement(_misc.StyledDropdown, {
          className: "list-menu"
        }, /*#__PURE__*/_react["default"].createElement("ul", null, _this.state.list.map(function (item, index) {
          return /*#__PURE__*/_react["default"].createElement("li", {
            key: item.description.toString()
          }, /*#__PURE__*/_react["default"].createElement("button", {
            className: index === _this.state.selectedListIndex ? 'selected' : '',
            onMouseDown: function onMouseDown() {
              return _this.itemClick(item);
            }
          }, item.description));
        }))));
      }
      if (_this.state.searchingResults) {
        return /*#__PURE__*/_react["default"].createElement(_misc.StyledDropdown, {
          className: "list-menu searching-menu"
        }, _this.props.labels.SEARCHING_LABEL);
      }
      if (_this.state.emptyResults) {
        return /*#__PURE__*/_react["default"].createElement(_misc.StyledDropdown, {
          className: "list-menu empty-results-menu"
        }, _this.props.labels.NO_RESULTS_FOUND_LABEL);
      }
      return false;
    });
    _defineProperty(_assertThisInitialized(_this), "renderEmployeesDropdown", function () {
      var extraInfo = _this.props.extraInfo;
      if (_this.state.showResultsDropdown && _this.state.searchValue.length >= 3) {
        return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_misc.StyledDropdown, {
          className: "list-menu"
        }, /*#__PURE__*/_react["default"].createElement("ul", {
          className: "list-menu-wrapper"
        }, _this.state.list.map(function (item, index) {
          return /*#__PURE__*/_react["default"].createElement("li", {
            key: item.employeeId.toString(),
            className: "list-menu-items"
          }, /*#__PURE__*/_react["default"].createElement("button", {
            className: index === _this.state.selectedListIndex ? 'selected' : '',
            onMouseDown: function onMouseDown() {
              return _this.itemClick(item);
            }
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: "result-name"
          }, item.employeeName), /*#__PURE__*/_react["default"].createElement("div", {
            className: "result-details"
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: "result-id"
          }, item.employeeId), /*#__PURE__*/_react["default"].createElement("div", {
            className: "result-country"
          }, R.prop(extraInfo)(item) || '-'))));
        }))));
      }
      if (_this.state.searchingResults && _this.state.searchValue.length >= 3) {
        return /*#__PURE__*/_react["default"].createElement(_misc.StyledDropdown, {
          className: "list-menu searching-menu"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "result-details"
        }, _this.props.labels.SEARCHING_LABEL));
      }
      if (_this.state.emptyResults && _this.state.searchValue.length >= 3) {
        return /*#__PURE__*/_react["default"].createElement(_misc.StyledDropdown, {
          className: "list-menu empty-results-menu"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "result-details"
        }, _this.props.labels.NO_RESULTS_FOUND_LABEL));
      }
      return false;
    });
    _defineProperty(_assertThisInitialized(_this), "renderFormula", function (value, description, searchValue, displayName) {
      // if we're searching something and the field already has a
      // value, temporarily show empty
      if (searchValue) return '';
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: "formula-value"
      }, displayName || description || R.prop('length', value) > NUMERIC_CUTOFF ? /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_tooltip.Tooltip, {
        id: "tip-".concat(value)
      }), /*#__PURE__*/_react["default"].createElement("span", {
        "data-tip": "".concat(description || value),
        "data-for": "tip-".concat(value),
        "data-place": "bottom",
        "data-offset": "{'bottom': 10}"
      }, displayName || value)) : value);
    });
    _this.state = {
      isNumeric: props.type === 'numeric' || props.type === 'percentage' || props.percentageOnly || props.numericOnly,
      list: [],
      searchValue: '',
      showResultsDropdown: false,
      selectedListIndex: 0,
      searchingResults: false,
      emptyResults: false
    };
    return _this;
  }
  _createClass(Searchable, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        value = _this$props.value,
        description = _this$props.description,
        error = _this$props.error,
        labels = _this$props.labels,
        displayName = _this$props.displayName,
        disabled = _this$props.disabled,
        id = _this$props.id,
        className = _this$props.className,
        employeeSearchable = _this$props.employeeSearchable,
        searchIcon = _this$props.searchIcon,
        ruleIndex = _this$props.ruleIndex,
        width = _this$props.width,
        keysPath = _this$props.keysPath;
      var _this$state = this.state,
        searchValue = _this$state.searchValue,
        isNumeric = _this$state.isNumeric;
      return /*#__PURE__*/_react["default"].createElement(_SearchableDEPRECATED["default"], {
        disabled: disabled,
        className: className,
        value: value,
        isNumeric: isNumeric,
        employeeSearchable: employeeSearchable,
        searchIcon: searchIcon,
        itemsLength: this.state.list.length,
        error: error,
        width: width,
        isFocused: this.props.isFocused,
        onBlur: this.handleClickOutside
      }, /*#__PURE__*/_react["default"].createElement("label", {
        htmlFor: id || "rule-".concat(ruleIndex, "-formula-input-").concat(keysPath.join('-')),
        className: "formula-wrapper-label"
      }, this.renderFormula(value, description, searchValue, displayName), !disabled && this.renderSearchableComponent({
        value: value,
        searchValue: searchValue
      }), !employeeSearchable ? this.renderDropdown() : this.renderEmployeesDropdown()), error && /*#__PURE__*/_react["default"].createElement(_InputError["default"], {
        message: labels.RULES_BUILDER_VARIABLE_MISSING
      }));
    }
  }]);
  return Searchable;
}(_react["default"].PureComponent);
Searchable.defaultProps = {
  description: '',
  error: undefined,
  isFocused: false,
  disabled: false,
  placeholder: null,
  id: null,
  percentageOnly: false,
  numericOnly: false,
  value: '',
  displayName: '',
  type: '',
  className: 'searchable-input',
  employeeSearchable: false,
  searchIcon: false,
  extraInfo: 'country',
  width: '',
  regexPattern: '',
  ruleIndex: undefined,
  keysPath: []
};
Searchable.propTypes = {
  percentageOnly: _propTypes["default"].bool,
  numericOnly: _propTypes["default"].bool,
  ruleIndex: _propTypes["default"].number,
  id: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  type: _propTypes["default"].string,
  isFocused: _propTypes["default"].bool,
  error: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].bool]),
  labels: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired,
  description: _propTypes["default"].string,
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  displayName: _propTypes["default"].string,
  formulaChange: _propTypes["default"].func.isRequired,
  searchableAction: _propTypes["default"].func.isRequired,
  className: _propTypes["default"].string,
  employeeSearchable: _propTypes["default"].bool,
  searchIcon: _propTypes["default"].bool,
  extraInfo: _propTypes["default"].string,
  width: _propTypes["default"].string,
  regexPattern: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].instanceOf(RegExp)]),
  keysPath: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])), _propTypes["default"].number])
};
Searchable.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "onChange",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "value",
      "type": null
    }],
    "returns": null
  }, {
    "name": "handleClickOutside",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "handleItemSelect",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "event",
      "type": null
    }, {
      "name": "currentIndex",
      "type": null
    }],
    "returns": null
  }, {
    "name": "itemClick",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "item",
      "type": null
    }],
    "returns": null
  }, {
    "name": "handleKeyPress",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "event",
      "type": null
    }],
    "returns": null
  }, {
    "name": "handlingSearchableAction",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "searchValue",
      "type": null
    }],
    "returns": null
  }, {
    "name": "renderSearchableComponent",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "{ value, searchValue = value }",
      "type": null
    }],
    "returns": null
  }, {
    "name": "renderDropdown",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "renderEmployeesDropdown",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "renderFormula",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "value",
      "type": null
    }, {
      "name": "description",
      "type": null
    }, {
      "name": "searchValue",
      "type": null
    }, {
      "name": "displayName",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "Searchable",
  "props": {
    "description": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "error": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "bool"
        }]
      },
      "required": false
    },
    "isFocused": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "placeholder": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "id": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "percentageOnly": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "numericOnly": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "value": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "number"
        }]
      },
      "required": false
    },
    "displayName": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "type": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "className": {
      "defaultValue": {
        "value": "'searchable-input'",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "employeeSearchable": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "searchIcon": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "extraInfo": {
      "defaultValue": {
        "value": "'country'",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "width": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "regexPattern": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "instanceOf",
          "value": "RegExp"
        }]
      },
      "required": false
    },
    "ruleIndex": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "keysPath": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "union",
        "value": [{
          "name": "arrayOf",
          "value": {
            "name": "union",
            "value": [{
              "name": "string"
            }, {
              "name": "number"
            }]
          }
        }, {
          "name": "number"
        }]
      },
      "required": false
    },
    "labels": {
      "description": "",
      "type": {
        "name": "objectOf",
        "value": {
          "name": "string"
        }
      },
      "required": true
    },
    "formulaChange": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "searchableAction": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    }
  }
};
var _default = (0, _utils.withDeprecationNotice)(Searchable, 'This Searchable component is deprecated, please use Searchable.jsx');
exports["default"] = _default;